import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from './context/AppContext'
import { Suspense } from "react";
import Web from "./routes/Web";
import "./i18n";
import "./App.css";

function App() {
  return (
    <Router>
      <AppProvider>
        <Suspense>
          <div className="App">
            <Routes>
              <Route path="/" element={<Navigate to="/ka" replace />} />
              <Route path="/:locale/*" element={<Web />} />
            </Routes>
          </div>
        </Suspense>
      </AppProvider>
    </Router>
  );
}

export default App;
